import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {LocaleService} from '../../../../../micromate-learn-lib/src/lib/services/locale/locale.service';
import {BrandingService} from '../../../../../micromate-learn-lib/src/lib/services/branding/branding.service';
import {environment} from '../../../environments/environment.js';

@Component({
    selector: 'app-slack-success',
    templateUrl: './slack-success.component.html',
    styleUrls: ['./slack-success.component.scss'],
    standalone: false
})
export class SlackSuccessComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private localeService: LocaleService,
        private translate: TranslateService,
        public brandingService: BrandingService
    ) {
    }

    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    public async ngOnInit(): Promise<void> {
        this.route.queryParams.subscribe(params => {
            const organizationId = params['organizationId'];
            this.brandingService.setBrandingManually(organizationId);
        });

        const bestMatchingLocale = await this.localeService.getBestMatching(navigator.language);
        this.translate.use(bestMatchingLocale.supported);
    }

    public openSlackApp = async (): Promise<void> => {
        const appId = environment.slackAppId;
        window.open(`https://slack.com/app_redirect?app=${appId}`, '_blank');
        return Promise.resolve();
    }
}
